module.exports = __webpack_public_path__ + "templates-59e97cd7/template-4-73e728be0ddade28993d40c9c1b253b1.jpg";